import LocomotiveScroll from 'locomotive-scroll'

export let scroll:LocomotiveScroll|undefined;

document.addEventListener("DOMContentLoaded", () => {
	// Locomotive Scroll
	if (!matchMedia('(prefers-reduced-motion)').matches) {
		const scrollContainer = document.querySelector('[data-scroll-container]');

		if (scrollContainer instanceof HTMLElement) {
			scroll = new LocomotiveScroll({
				el: scrollContainer,
				smooth: true,
                getDirection: true
			});

			new ResizeObserver(() => scroll?.update()).observe(scrollContainer);
		}
	}
});